import { render, staticRenderFns } from "./coupon_task_detail.vue?vue&type=template&id=32c8db7e"
import script from "./coupon_task_detail.vue?vue&type=script&lang=js"
export * from "./coupon_task_detail.vue?vue&type=script&lang=js"
import style0 from "./coupon_task_detail.vue?vue&type=style&index=0&id=32c8db7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports